import React, { Component } from "react";

import { withStyles } from "@material-ui/core/styles";

import { Paper } from "@material-ui/core";
import Sidebar from "../../components/sidebar/sidebar";
import WorkRequest from "../work-request/work-request";
import TrackOrders from "../track-orders/track-orders";
import StoreHistory from "../store-history/store-history";
import WorkOrderDetails from "../work-order-details/work-order-details";

const styles = theme => ({
  mainApp: {
    margin: "5rem"
  },
  paperCls: {
    padding: "0rem .5rem",
    display: "flex",
    flexDirection: "column"
  },

  containerCls: {
    display: "flex",
    height: "99vh",
    width: "98vw"
  },
  sidebarCls: {
    width: "16%",
    // backgroundColor: "yellow",
    position: "relative",
    padding: ".25rem",
  },
  mainBodyCls: {
    flexGrow: "1",
    backgroundColor: "lightgrey",
    display:"flex"
  }
});

class MainPage extends Component {
  constructor() {
    super();

    this.state = {
      mode: 0,
      workOrder:"",
      storeid: -1
    };
  }

  getView() {
    switch (this.state.mode) {
      case 0: {
        return <WorkRequest customerDetail={this.props.customerDetail} />;
      }

      case 1:{
        return <TrackOrders customerDetail={this.props.customerDetail} showWorkOrder={this.showWorkOrder} />
      }

      case 2:{
        return <StoreHistory customerDetail={this.props.customerDetail}/>
      }

      case 3:{
        if(this.state.workOrder !== ''){
          return <WorkOrderDetails workOrder={this.state.workOrder} storeid={this.state.storeid}/>
        }
        
      }

    }
  }

  showWorkOrder = (workOrder, storeid) =>{
    this.setState({
      workOrder,
      storeid,
      mode: 3
    }
    )
  }

  handleSelectionEvent = id => {
    this.setState({
      mode: id
    });
  };

  render() {
    const { classes } = this.props;

    return (
      <div>
        <Paper className={classes.paperCls}>
          <div className={classes.containerCls}>
            <div className={classes.sidebarCls}>
              <Sidebar customerDetail={this.props.customerDetail} selectionEvent={this.handleSelectionEvent} />
            </div>
            <div className={classes.mainBodyCls}>{this.getView()}</div>
          </div>
        </Paper>
      </div>
    );
  }
}

export default withStyles(styles)(MainPage);
